const INIT_QUERY: string = 'query/INIT_QUERY' as const;
const SET_SEARCHQUERY : string = 'query/SET_SEARCHQUERY' as const;

type initQueryAction = {
    type: typeof INIT_QUERY;
    payload: null;
};
type setQueryAction = {
    type: typeof SET_SEARCHQUERY;
    payload: InitialStateType;
}

type ActionType = initQueryAction | setQueryAction;

export const initQuery = () => ({type: INIT_QUERY});
export const setSearchQuery = (_query: {type: string, query: string}) => ({type: SET_SEARCHQUERY, payload: _query});

interface InitialStateType {
    type: string,
    query: string,
};

const initialState: InitialStateType = {
    type: '',
    query: '',
};

export default function query(state: InitialStateType = initialState, action: ActionType): InitialStateType {
    switch(action.type) {
        case INIT_QUERY:
            return initialState;
        case SET_SEARCHQUERY:
            return {
                type: action.payload.type,
                query: action.payload.query,
            };
        default:
            return state;
    }
}